import React from "react";
import { InternalLinkCard } from "@/components/InternalLinkCard";

interface RelatedService {
  title: string;
  description: string;
  href: string;
  badge?: string;
  keywords: string[];
}

interface RelatedServicesSectionProps {
  currentService: string;
  title?: string;
  description?: string;
}

const ALL_SERVICES: RelatedService[] = [
  {
    title: "Zonnepanelen Installatie",
    description: "Hoogrendement zonnepanelen met snelle terugverdientijd. Tot 70% energiebesparing.",
    href: "/zonnepanelen",
    badge: "Populair",
    keywords: ["zonnepanelen kosten", "PV panelen", "energiebesparing"]
  },
  {
    title: "Warmtepomp Installatie",
    description: "All electric warmtepomp met ISDE subsidie. 4x energiezuiniger dan CV-ketel.",
    href: "/warmtepompen",
    badge: "Subsidie",
    keywords: ["warmtepomp kosten", "van het gas af", "ISDE subsidie"]
  },
  {
    title: "Thuisbatterij Systemen",
    description: "Energie opslaan en verdienen tot €6.240 per jaar. Ook zonder zonnepanelen.",
    href: "/thuisbatterijen",
    keywords: ["thuisbatterij prijs", "energie opslaan", "batterij rendement"]
  },
  {
    title: "Zonneboiler Systemen",
    description: "Warm water van de zon. PVT panelen combineren stroom en warmwater opwekking.",
    href: "/zonneboilers",
    keywords: ["zonneboiler kosten", "PVT panelen", "warm water"]
  },
  {
    title: "Laadpaal Installatie",
    description: "Thuis laden met eigen zonnestroom. Slimme laadpalen met app-bediening.",
    href: "/laadpalen",
    keywords: ["laadpaal thuis", "wallbox", "elektrisch rijden"]
  },
  {
    title: "Airco & Koeling",
    description: "Energie-efficiënte koeling en verwarming in één systeem met warmtepomp technologie.",
    href: "/airco",
    keywords: ["airco installatie", "split unit", "koeling"]
  },
  {
    title: "Smart Home",
    description: "Complete domotica automatisering met Loxone systemen voor maximaal comfort en energiebesparing.",
    href: "/smarthome",
    badge: "Loxone Partner",
    keywords: ["domotica", "automatisering", "loxone"]
  }
];

export const RelatedServicesSection: React.FC<RelatedServicesSectionProps> = ({
  currentService,
  title = "Gerelateerde Energieoplossingen",
  description = "Ontdek onze andere duurzame energieoplossingen die perfect combineren met"
}) => {
  // Filter out current service and show 3 most relevant ones
  const relatedServices = ALL_SERVICES
    .filter(service => !service.href.includes(currentService))
    .slice(0, 3);

  return (
    <section className="py-12 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold mb-4">{title}</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {description} {currentService}. Maak uw woning volledig energieneutraal.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {relatedServices.map((service, index) => (
            <InternalLinkCard
              key={index}
              title={service.title}
              description={service.description}
              href={service.href}
              badge={service.badge}
              keywords={service.keywords}
            />
          ))}
        </div>
        
        <div className="text-center mt-8">
          <p className="text-sm text-muted-foreground">
            <strong>Combinatie voordeel:</strong> Krijg extra korting bij het afnemen van meerdere diensten. 
            <a href="/contact" className="text-primary hover:underline ml-1">
              Vraag om een gecombineerde offerte →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default RelatedServicesSection;